<template>
  <div
    class="list-inner"
    ref="listInner"
    v-if="tasklist">
    <!--I want to finish these tasks <font-awesome-icon :icon="['fa', 'star']" />-->
    <!--Not planned yet <font-awesome-icon :icon="['far', 'star']" />-->
    <!--
    <div
      v-if="isDayplan && !showReducedDayplan"
      class="text-center"
      style="color: #666; font-weight: 700;">
      <div v-if="!unplannedOnly && 0">
        Finish this session ({{ itemCountPlanned }} tasks)
      </div>
      <div v-if="unplannedOnly">
        Tasks in backlog
      </div>
    </div>
    -->
    <draggable
      v-model="draggablesList"
      ref="draglist"
      :class="{
        'task-list-drag-area': true,
        'task-list-drag-area--draggable': listIsEditable,
        'task-list-drag-area--isempty': showPlaceholder,
        'task-list--is-backlog': unplannedOnly,
      }"
      :scroll="true"
      :scrollSensitivity="100"
      :animation="50"
      :swapThreshold="0.25"
      :forcePlaceholderSize="true"
      :forceFallback="false"
      :disabled="savingDrag || !listIsEditable"
      draggable=".item"
      group="tasks"
      :setData="setDragData"
      :onChange="onChange"
      @start="onDragStart"
      :move="onDragMove"
      @end="onDragAdd($event, 'end')"
      @add="onDragAdd($event, 'add')"
      @sort="onDragAdd($event, 'sort')" >

      <!-- <div class="task item sortable-ghost sortable-chosen">TEST</div> -->
      <!-- handle=".list" -->

      <TaskListItem
        class="item"
        v-for="element in draggablesList"
        ref="tasks"
        :key="element.$key"
        :is-editable="listIsEditable"
        :data-element-id="element.$id"
        :data-member-id="element.memberId"
        :goal-id="goalId"
        :html-title="element.matched_text"
        :enable-proportional-task-heights="showPropTaskHeight"
        :member-id="element.memberId/*assignedUserId*/"
        :lane-assigned-user-id="assignedUserId"
        :lane-id="listId"
        :task="element"
        :finish-date="finishDates && finishDates[element.$id] ? finishDates[element.$id] : 0"
        :active-task="activeTask"
        @focus="unfocusAllTasks( $event )"
        @move-to-top="moveTaskToTop( element )"
        :durationInSession="taskDurationInSession(element.$id)"
        :timeInSessionFrom="taskTimeInSessionFrom(element.$id)"
        :isDayplan="isDayplan"
        :sessionId="sessionId"
        :tasksInSession="tasksInSession"
        :hide-additional-buttons="showReducedDayplan"
        :listType="listType"
        />

      <!-- NOTE: must be v-show -->
      <TaskListItemNew
        v-show="show_new_task"
        ref="new_task"
        @cancel="show_new_task = false"
        @task-creating="appendNewTask"
        :goal-id="goalId"
        :member-id="assignedUserId"
        :lane-id="listId"
        :sessionId="sessionId"
        :tasksInSession="tasksInSession"
        class="item"
        />
    </draggable>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Draggable from 'vuedraggable';
import TaskListItem from '@/components/GoalPage/Elements/TaskListItem';
import TaskListItemNew from '@/components/GoalPage/Elements/TaskListItemNew';
import TaskManagementMixin from "@/components/Mixins/TaskManagement"

//import clonedeep from "lodash.clonedeep";

// TODO: TaskListItem -> TaskListItem

/*
ACTIONS:
? this.goal_task_add_checklist_item({ goal_id, task_id, data });
? this.goal_task_rem_checklist_item({ goal_id, task_id, item_id });
? this.goal_task_update_checklist_item({ goal_id, task_id, item_id, data });
? this.goal_task_move_checklist_items_batch({ goal_id, task_id, batch });

GETTERS:
? this.get_task_by_goal_id_and_task_id(goal_id, task_id);
? this.checklist_items_by_goal_id_and_task_id(goal_id, task_id);
*/

export default {
  name: 'TaskList',
  mixins: [ TaskManagementMixin ],
  props: {
    goalId: {
      type: String,
      default: null
    },
    tasklist: {
      /* Format:
      Array of tasks
      */
      type: Array,
      default: () => {return []}
    },
    tasklistAll: {
      /* Format:
      Array of tasks
      */
      type: Array,
      default: () => {return []}
    },
    allowToReorder: {
      /* This only makes sense when all tasks come from one lane! */
      default: false
    },
    listId: {
      /* List can be given a unique id (usualy the lane id) to detect drag
         and drop between lists. */
      default: null
    },
    listIsEditable: {
      default: true
    },
    assignedUserId: {},
    showPropTaskHeight: {},
    finishDates: {
      type: Object,
      default: null
    },
    activeTask: {
      type: Object,
      default: null
    },
    tasksInSession: {
      type: Array,
    },
    // width: {
    //   type: String
    // },
    isDayplan: {
      type: Boolean
    },
    sessionId: {
      type: String
    },
    unplannedOnly: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String
    },
    showReducedDayplan: {
      type: Boolean,
      default: false
    },
    itemCountPlanned: {
      type: Number
    }
  },
  data: () => ({
    show_new_task: false,
    DEBUG: false,
    new_goal_title: "test",
    task_dragging: false, // use store value instead (kann komplett raus)
    savingDrag: false
  }),
  watch: {
    /*
    tasklist: {
      // TODO: Use this when allowing drag and drop of task on other things:

      deep: false,
      handler(value) {
        if ( value && !this.setDataMounted ) {
          this.$nextTick(() => {
            console.log("* attaching sortable setData *");
            this.$refs.draglist._sortable.options.setData = (dataTransfer, dragEl) => {

              let elementId = dragEl.dataset.elementId;
              let item = this.tasklist.find(item => item.id === elementId);
              item.goalId = this.goal_id;

              dataTransfer.setData('text', JSON.stringify(item));
              console.log("_sortable.setData", item, dataTransfer);
            }
          })
          this.setDataMounted = true;
        }
      }
    }
    */
  },
  computed: {
    // itemCount() {
    //   return this.tasklist.length;
    // },

    showPlaceholder() {
      return this.draggablesList.length === 0
          && this.isDayplan;
    },

    // customWidth() {
    //   if (this.width) {
    //     return { 'width': this.width }
    //   } else {
    //     return {}
    //   }
    // },

    draggablesList: {
      get() {
        return this.tasklist;
      },
      set(items) {
        if ( !this.allowToReorder ) {
          console.warn("Reordering is not allowed!");
        }
      }
    },
  },
  methods: {
    ...mapActions("dayplanner", [
      //'createSnapshot',
      'setDragTargetDate',
      'setDragTargetIndex',
      'setDragItem',
      'setDragActive'
    ]),
    ...mapActions("goal", [
      // "move_task_batch",
      // "goal_assign_task_to_lane",
      // "goal_task_add_checklist_item",
      // "goal_task_rem_checklist_item",
      // "goal_task_update_checklist_item",
      // "goal_task_move_checklist_items_batch",
    ]),
    ...mapMutations("calendar", ["DRAG_START", "DRAG_END"]),

    taskDurationInSession(taskId) {
      let duration = 0
      if (this.tasksInSession && this.tasksInSession.length > 0) {
        let task = this.tasksInSession.find(task => task.taskId === taskId)
        if (task) {
          duration = task.durationInSession
        }
      }
      return duration
    },
    taskTimeInSessionFrom(taskId) {
      let from = null
      if (this.tasksInSession && this.tasksInSession.length > 0) {
        let task = this.tasksInSession.find(task => task.taskId === taskId)
        if (task) {
          from = task.from
        }
      }
      return from
    },

    moveTaskToTop(task) {

      // TODO: During Search / Filtering this will move the task to the top of the filtered (!) list
      let sortidx_first = this.draggablesList.length > 0
                        ? this.draggablesList[0].sortidx || 1
                        : 1;

      let sortidx = sortidx_first * 0.9;

      this.$models.taskMeta.with({
        goalId: this.goalId, uid: task.memberId
      }).update(task.$id, { sortidx })
    },

    onDragStart($event) {
      this.task_dragging = true;
      let oldIndex = $event.oldIndex
      /*if (!this.isDayplan) {
        oldIndex = $event.oldIndex + 1
      }*/
      this.task_dragging = true;
      let task = this.draggablesList[oldIndex]
      console.log('onDragStart', $event, this.listType, 'task', task)
      let item = {
        goalId: this.goalId,
        memberId: this.assignedUserId,
        listId: this.listId,
        listType: this.listType,
        taskId: task.$id,
        sessionId: this.sessionId || null,
        oldIndex: oldIndex,
        type: 'TASK',
        from: 0,
        to: task.$state.durationRemaining,
        dragConfig: {
          duration: task.$state.durationRemaining,
          shiftingEnabled: true,
          placeAtEnd: false
        }

      }

      if (this.sessionId) {
        let session = this.$models.userDayplannerSessions.subscribeNode(this.sessionId)
        session.$promise.then(() => {
          if (session) {
            console.log('maSession', session)
            this.setDragTargetDate(session.$state.dateString) // MUST BE SESSION DATE
            //this.setDragTargetIndex(oldIndex) // MUST BE INDEX OF SESSION
            this.setDragItemType('TASK')
            this.unfocusAllTasks();
            this.$nextTick(() => {
              this.onDragTaskStart(item)
            })
          }
        })
      } else {
        this.onDragTaskStart(item)
        this.unfocusAllTasks();
      }
    },

    setDragData(dataTransfer, element) {
      // console.log('setDragData', dataTransfer, element)
      let payload = {
        taskId:   element.dataset.elementId,
        memberId: element.dataset.memberId,
        goalId:   this.goalId,
        listId:   this.listId,
      }
      dataTransfer.effectAllowed = 'move';
      dataTransfer.setData("text/plain", JSON.stringify(payload));
    },

    onChange(evt) {
    },

    onDragAdd($event, type) {
      let newIndex = $event.newIndex
      let destination = {
        goalId: this.goalId,
        memberId: this.assignedUserId,
        listId: this.listId,
        listType: this.listType,
        sessionId: this.sessionId || null,
        tasksInSession: this.tasksInSession,
        trigger: 'DragAdd',
        draggablesList: this.draggablesList,
        tasklistAll: this.tasklistAll,
        newIndex: newIndex
      }
      //console.log('onDragAdd destination', destination, type)
      //this.$emit('drag-end', destination);

      this.onDragTaskEnd(destination)
    },
    onDragSort(evt) {
      //console.log("onDragSort", evt);
      //this.draggablesListVirtual = clonedeep(this.draggablesList)
    },

    onDragMove($event) {
      //console.log('onDragMove', $event)

      let newIndex = null
      let dateString = null
      if ($event.related.attributes.getNamedItem('date-string') && $event.draggedContext.element) {
        dateString = $event.related.attributes.getNamedItem('date-string').nodeValue
        //console.log('onDragMove dateString', dateString)
        newIndex = $event.draggedContext.futureIndex

        if (newIndex && !isNaN(newIndex)) {

          if (dateString) {
            this.setDragTargetDate(dateString)
            //console.log('onDragMoveindices set newIndex',newIndex)
            this.setDragTargetIndex(newIndex)
            this.setDragActive(true)
          }
        }
        if (!newIndex || this.drag_target_status_ok === false) {
          //console.log('onDragMove returning false for placement', !newIndex, this.drag_target_status_ok === false)
          return false
        }
      }
      //let cancelDrag = !Array.from($event.related.classList).includes("action-draggable--filtered");
      //console.log('onDragMove newIndex:', newIndex)
    },

    appendNewTask() {
      this.show_new_task = true
      this.$nextTick(() => {
        this.$refs.new_task.focus()
        this.scrollToBottom();
      })
    },

    focusOnTask( taskId ) {
      /* Called externally */
      let taskRef = this.$refs.tasks.find(taskRef => taskRef.task.$id === taskId);
      if ( taskRef ) {
        taskRef.onFocusRenameTask();
      }
    },

    unfocusAllTasks( exception ) {
      /* TODO: This would be a better use case for the Vuex store, also then
      it is possible to include all lists */
      this.$refs.tasks.forEach(taskRef => {
        if ( taskRef && taskRef.task.$id !== exception ) {
          taskRef.unfocus();
        }
      })
    },

    scrollToBottom() {
      let element_to_scroll_to = this.$refs.listInner
      element_to_scroll_to.scrollTo( 0, element_to_scroll_to.scrollHeight )
    },

    /*onAddTaskToSession({ task }) {
      console.log('onAddTaskToSession write to db', task, this.tasksInSession)
      let tasks = [...this.tasksInSession.filter(item => item.taskId !== task.taskId), task]
      this.$models.userDayplannerSessions.update(this.sessionId, {
        tasks: tasks
      })
    },

    onRemoveTaskFromSession({ taskId }) {
      let tasks = [...this.tasksInSession.filter(item => item.taskId !== taskId)]
      this.$models.userDayplannerSessions.update(this.sessionId, {
        tasks: tasks
      })
    },*/
  },
  components: {
    TaskListItem,
    Draggable,
    TaskListItemNew,
  },
};
</script>

<style>
.task-list-drag-area {
  min-height: 40px;
  padding: 0;
}
.task-list-drag-area:empty {
  background: red;
}
.task-list-drag-area.task-list-drag-area--isempty {
  min-height: 50px;
  border: 1px dashed #BBB;

  /*margin-left: 0.5rem;*/
  /*margin-right: 0.5rem;*/

  padding: 0;
  border-radius: 3px;

  /* .kanban-list-space-right */
  margin-right: 24px;
}
.dayplan--reduced .task-list-drag-area.task-list-drag-area--isempty {
  margin-right: 0;
}

/* Placeholder text, when drag list is empty */
.task-list-drag-area.task-list-drag-area--isempty::before {
  content: "Drag tasks here";
  position: absolute;
  /*top: calc(50% - 5pt);*/
  /*top: 40px;*/
  bottom: 15px;
  width: 96%; /* HACK */
  text-align: center;
  font-size: 10pt;
  font-weight: bold;
  color: #BBB;
}

.list .list-inner .task-list--is-backlog .task {
    /*background: #F5F5F5;*/
    opacity: 0.6;
    /*border: 1px dashed #9e9e9e;*/
}

/* Workaround to replace drop zone border with sortable ghost border */
/*
.task-list-drag-area .sortable-ghost {
  background: white !important;
  z-index: 2;
}
.task-list-drag-area.task-list-drag-area--isempty .sortable-ghost {
  background: white !important;
  border: none !important;
}
*/
</style>
